














































import hash from 'object-hash';
import { listFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
// eslint-disable-next-line no-unused-vars
import { Table, Row, Cell } from '@/main/utils/table';
// eslint-disable-next-line no-unused-vars
import { isRouteEvent, RouteEvent } from '@/main/pages/page';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
// eslint-disable-next-line no-unused-vars
import Save from '#components/dms/button/Save.vue';

import { NAME, COLUMN_GAR_SZB, COLUMN_HOD_SZB, COLUMN_INTERNAL_HOURLY_RATE } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		DmsEditableTable,
		'dms-save': Save,
	},
	data() {
		return{
			previousWarrentyRate: null as number | null,
			previousInternalHourlyRate: null as number | null,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tabulkovaPozice: `${this.storeUri}/${listMutations.TABULKOVA_POZICE_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${listMutations.NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		disabledHodSzb(): boolean {
			return true;//(Bug #19650) !this.ProvozovnaId || !this.VyrobekvozOzn;
		},
		disabledHodSzbUpdate(): boolean {
			return this.disabledHodSzb || this.loadingTable;
		},
		nakladoveStrediskoFilter(): Record<string, any> {
			return { ProvozovnaId: this.ProvozovnaId, StrnakltypOzn: this.StrnakltypOzn, StrednaklOzn: this.StrednaklOzn };
		},
		isModified(): boolean {
			return this.table.hash !== hash(this.table.rows);
		},
		saveDisabled(): boolean {
			return this.loading || this.loadingTable;
		},
		loadingTable(): boolean {
			return this.table.loadingCount > 0;
		},
	},
	methods: {
		async beforeUnload(event: BeforeUnloadEvent | RouteEvent | null) {
			await this.doBeforeUload(event);
			if (isRouteEvent(event)) {
				const next = (!this.shouldRemoveFromPageManager(event.to) || await this.checkUnsaveChanges());
				if (next) {
					await this.handleRemovingFromPageManager(event.to);
					event.next();
				}
			}
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			const warrantyColIndex: number = this.table.cellNames!.GAR_SZB!;
			this.previousWarrentyRate = row.cells[warrantyColIndex];
			const internalHourlyRateColIndex: number = this.table.cellNames!.INTERNAL_HOURLY_RATE!;
			this.previousInternalHourlyRate = row.cells[internalHourlyRateColIndex];
		},
		async checkUnsaveChanges() {
			if (this.isModified) {
				return this.showConfirm({
					message: this.LocalizeChyboveHlasky('PageLeaveMsg'),
					title: this.Localize('ShowMsg'),
					options: {
						confirmButtonText: this.LocalizeChyboveHlasky('PageLeaveLeaveBtn'),
						cancelButtonText: this.LocalizeChyboveHlasky('PageLeaveStayBtn'),
						type: 'warning',
					},
				});
			}
			return true;
		},
		async handleSave() {
			try {
				this.startLoading();
				await this.saveTable();
			} finally {
				this.table.hash = hash(this.table.rows);
				this.endLoading();
			}
		},
		async updateSazbyZaklad() {
			if (!this.ProvozovnaId || !this.VyrobekvozOzn) {
				this.hodSzb = null;
				this.garSzb = null;
				this.internalHourlyRate = null;
			} 
			// Kept for future ref (Bug fix #19650)
			// else {
			// 	try {
			// 		this.loadingSazbyZaklad = true;
			// 		const { data } = await apiProvider.fetchSazbyZaklad({ ProvozovnaId: this.ProvozovnaId, VyrobekvozOzn: this.VyrobekvozOzn });
			// 		this.hodSzb = data.HodSzb;
			// 		this.garSzb = data.GarSzb;
			// 		this.internalHourlyRate = data.InternalHourlyRate;
			// 	} finally {
			// 		this.loadingSazbyZaklad = false;
			// 	}
			// }
		},
		updateHodSzb() {
			this.updateTableColumn({ value: this.hodSzb, columnName: COLUMN_HOD_SZB });
		},
		updateGarSzb() {
			this.updateTableColumn({ value: this.garSzb, columnName: COLUMN_GAR_SZB });
		},
		updateInternalHourlyRate() {
			this.updateTableColumn({ value: this.internalHourlyRate, columnName: COLUMN_INTERNAL_HOURLY_RATE });
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			const warrantyColIndex: number = this.table.cellNames!.GAR_SZB!;
			const newWarrantyRate = newRow.cells[warrantyColIndex] === null ? 0 : newRow.cells[warrantyColIndex];
			const internalHourlyRateColIndex: number = this.table.cellNames!.INTERNAL_HOURLY_RATE!;
			const newInternalHourlyRate = newRow.cells[internalHourlyRateColIndex] === null ? 0 : newRow.cells[internalHourlyRateColIndex];
			if (newWarrantyRate < 0 || newInternalHourlyRate < 0) {
				if (newWarrantyRate < 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Warranty_Negative_Error_Msg') });
					newRow.cells[warrantyColIndex] = this.previousWarrentyRate;
				} if (newInternalHourlyRate < 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Internal_Hourly_Rate_Negative_Error_Msg') });
					newRow.cells[internalHourlyRateColIndex] = this.previousInternalHourlyRate;
				}
			} else if ((this.previousWarrentyRate !== newWarrantyRate || this.previousInternalHourlyRate !== newInternalHourlyRate)) {
				this.showConfirm({
					message:  this.LocalizeChyboveHlasky('Warranty_Change_Warning_Msg'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						confirmButtonText: this.Localize('Ano'),
					    cancelButtonText: this.Localize('Ne'),
						callback: async (action) => {
							if (action === 'confirm') {
								//Update all warranty rate of selected brand with new warranty rate.
								const brandColIndex: number = this.table.cellNames!.X_VYROBEKVOZ_OZN!;
								const warehouseColIndex: number = this.table.cellNames!.X_PROVOZOVNA_ID!;
								const brandName = newRow.cells[brandColIndex];
								const warehouseName = newRow.cells[warehouseColIndex];
								if(this.previousWarrentyRate !== newWarrantyRate) {
									this.updateWarrantyRateOfBrand(brandName, warehouseName, newWarrantyRate);
								}
								if(this.previousInternalHourlyRate !== newInternalHourlyRate) {
									this.updateInternalRateOfBrand(brandName, warehouseName, newInternalHourlyRate);
								}
							}
							else {
								//Reset to previous value.
								newRow.cells[warrantyColIndex] = this.previousWarrentyRate;
								newRow.cells[internalHourlyRateColIndex] = this.previousInternalHourlyRate;
							}
						}
					},
				});
			} else if (newWarrantyRate === 0 || newInternalHourlyRate === 0) {
				newRow.cells[warrantyColIndex] = newWarrantyRate;
				newRow.cells[internalHourlyRateColIndex] = newInternalHourlyRate;
			}
		},
		updateWarrantyRateOfBrand(brandName:string, warehouseName:string, warrantyRate:number, ) {
			try {
				this.startLoading();
				const brandColIndex: number = this.table.cellNames!.X_VYROBEKVOZ_OZN!;
				const warrantyColIndex: number = this.table.cellNames!.GAR_SZB!;
				const warehouseColIndex: number = this.table.cellNames!.X_PROVOZOVNA_ID!;
				let rowsToUpdate = this.table.rows.filter((row) => row.cells[brandColIndex] === brandName && row.cells[warehouseColIndex] === warehouseName);
				rowsToUpdate?.map((row) => {row.cells[warrantyColIndex]= warrantyRate});
			}
			finally {
				this.endLoading();
			}
		},
		updateInternalRateOfBrand(brandName:string, warehouseName:string, newInternalHourlyRate:number, ) {
			try {
				this.startLoading();
				const brandColIndex: number = this.table.cellNames!.X_VYROBEKVOZ_OZN!;
				const internalHourlyRateColIndex: number = this.table.cellNames!.INTERNAL_HOURLY_RATE!;
				const warehouseColIndex: number = this.table.cellNames!.X_PROVOZOVNA_ID!;
				let rowsToUpdate = this.table.rows.filter((row) => row.cells[brandColIndex] === brandName && row.cells[warehouseColIndex] === warehouseName);
				rowsToUpdate?.map((row) => {row.cells[internalHourlyRateColIndex]= newInternalHourlyRate});
			}
			finally {
				this.endLoading();
			}
		},
	},
	watch: {
		ProvozovnaId(newProvozovnaId) {
			if (!newProvozovnaId) {
				this.StrednaklOzn = null;
				this.StrednaklOznText = null;
			}
			this.updateSazbyZaklad();
		},
		VyrobekvozOzn(newVyrobekvozOzn) {
			if (!newVyrobekvozOzn) {
				this.TablpoziceText = null;
			}
			this.updateSazbyZaklad();
		},
	},
});
